import { computed } from 'vue'
import { useUIStore } from '@/js/stores/uiStore'
import { useRogue } from '@/js/services/Rogue'

export const CHAT_OVERLAY = 'chat-widget'

export function useLiveChat() {
  const rogue = useRogue()
  const uiStore = useUIStore()

  const chatKey = computed(() => rogue.keys.zendesk)

  const hasLiveChat = computed(() => !!chatKey.value)

  // Messaging answers 24/7 through its AI agent
  const chatOnline = true

  function openLiveChat(): void {
    uiStore.showOverlay(CHAT_OVERLAY, rogue)
  }

  return {
    chatKey,
    hasLiveChat,
    chatOnline,
    openLiveChat,
  }
}
